<template>
  <Layout>
    <div class="ep__main_content pt-80">
      <section class="content pt-40 pb-40">
        <div class="container page p-0" v-html="termOfUseContent"></div>
      </section>
    </div>
  </Layout>
</template>
<style lang="scss">
.page {
  background: white;
  border-radius: 4px;

  .title {
    display: flex;
    place-items: center;
    border-bottom: 1px solid #ebebeb;
    padding-left: 40px;

    h1 {
      font-family: "Proxima Nova bold", sans-serif;
      font-weight: 700;
      color: #000000;
      font-size: 42px;
      line-height: 52px;
      margin: 40px 0 30px 0;
    }

    @media (max-width: 768px) {
      h1 {
        font-size: 36px;
        line-height: 44px;
        margin: 40px 0 40px 0;
      }
    }
  }
  .content {
    padding: 0 40px 56px;

    p {
      font-size: 18px;
      line-height: 24px;
      margin: 8px 0 0 0;
    }

    h2 {
      font-family: "Proxima Nova bold", sans-serif;
      line-height: 30px;
      font-size: 24px;
      margin: 56px 0 10px 0;
      color: #004d6c;
    }

    ul {
      list-style-type: none;
      margin: 16px 0 0 0;
      padding-left: 32px;

      li {
        list-style: none;
        line-height: 24px;
        margin-bottom: 24px;
      }
    }

    @media (max-width: 768px) {
      h2:first-child {
        margin-top: 40px;
      }
    }
  }
}
</style>
<script>
import Layout from '@/components/Layout'
import { settingsMixin } from '@/mixins/settings-mixin'
import { META_DESCRIPTION, META_DESCRIPTION_DEFAULT_PROP } from '@/utils/constants'
import { getTermOfUseContent } from '@/repositories/StaticAsset'

export default {
  metaInfo: {
    meta: [{
      ...META_DESCRIPTION_DEFAULT_PROP,
      content: META_DESCRIPTION.TERMS_OF_USE
    }]
  },
  name: 'TermOfUse',
  components: {
    Layout
  },
  mixins: [settingsMixin],
  props: {
    countryCode: {
      type: String
    }
  },
  data () {
    return {
      termOfUseContent: ''
    }
  },
  mounted () {
    getTermOfUseContent(this.countryCode, this.languageCode).then((data) => {
      this.termOfUseContent = data
    })
  }
}
</script>
